export { SuiLocalizationModule, SuiLocalizationService } from "./index";
